import statistic from './statistic'

export default {
  settings: {
    hasOvertime: true,
    hasShootouts: true,
    hasDelayedEvents: true
  },
  actionTypes: {
    numberOfPlayersChangeEvents: [
      '5_MIN_PENALTY',
      '10_MIN_PENALTY',
      'UNTIL_GAME_ENDS_PENALTY',
      'PLAYER_ON_PITCH',
      'ADJUST_TEAMS',
      'TEAM_CORRECTION'
    ]
  },
  modules: {
    info: [
      {
        type: 'timer',
        component: 'hockey-ball-timer',
        props: {
          additionalTime: ingameData => ingameData.additionalTimeInPeriod
        }
      },
      {
        type: 'players',
        props: {
          home: ingameData => ingameData.playersCount.home,
          away: ingameData => ingameData.playersCount.away,
          customClass: ingameData => {
            const { untilGameEndPenaltyCount } = ingameData

            if (untilGameEndPenaltyCount) return 'football-players-count-changed'

            return ''
          }
        }
      },
      {
        type: 'periods',
        props: {
          className: 'liveCardPeriods__slider_left liveCardPeriods__slider_hockey-ball'
        }
      }
    ],
    score: {
      component: 'score-component',
      score: ingameData => ingameData.score
    },
    fieldScheme: {
      component: 'hockey-field'
    },
    statistic,
    eventLog: true
  },
  storeScheme: {
    score: {
      home: 0,
      away: 0
    },
    playersCount: {
      home: 11,
      away: 11
    },
    shootoutsLog: {
      home: [],
      away: []
    },
    leftSideTeam: 1,
    getOvertimePeriodName: 'OT',
    shootoutPeriodName: 'SO',
    shootoutStatisticTitle: 'trader.penalty.shootout.score.bullets',
    additionalTimeInPeriod: {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0
    },
    untilGameEndPenaltyCount: 0
  }
}
